<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_006 (グループ)
 * @created at      :   2026/01/21
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST006 from '@/views/popupSearch/PopupMST006/store';
import helpers from '@/utils/helpers';

var PopupMST006Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST006')) {
            store.registerModule('PopupMST006', PopupMST006);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST006', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST006', ['searchGroupInfo']),
        ...mapMutations('PopupMST006', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.center_cd !== undefined) {
                    this.data.center_cd = this.initData.center_cd;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.group_cd !== undefined) {
                    this.data.group_cd = this.initData.group_cd;
                }
                if (this.initData.group_name !== undefined) {
                    this.data.group_name = this.initData.group_name;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.group_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchGroupInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchGroupInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.group_cd);
            this.$emit('onReferValueName', item.group_name);
            this.$emit('close');
        }
    }
};
export default PopupMST006Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
